import React, { useEffect, useState } from "react";
import { useMaskRu } from "../../../hooks/phone-mask/use-mask-ru";
import { Input } from "../../../shared/input/Input";
import { postFindUser } from "../../helpers/Api";
import './ClientData.scss';

export function ClientData({
  inputPhone,
  setInputPhone,
  formik,
  isFocused,
  setIsFocused,
  setDiscountPhone
}) {

  const country = 'RU';
  const inputCode = '+7 (';

  const handlePhoneChange = (value) => {
    formik.setFieldValue('phone', value.length !== 0 ? inputCode + value : '');
  };

  const { onPhoneInput, onPhoneKeyDown, onPhoneClick, onPhoneFocus, onPhonePaste } = useMaskRu(
    country,
    inputCode,
    setInputPhone,
    handlePhoneChange);

  useEffect(() => {
    if (formik.values.phone.length === 18) {
      postFindUser({
        phone: formik.values.phone
      }).then((res) => {
        setDiscountPhone(res.data.discount);
      })
        .catch(e => {
          if (e.response.status === 404 || e.response.status === 400) {
            setDiscountPhone(0)
            return
          }
        })
    } else if (formik.values.phone.length < 18) {
      setDiscountPhone(0)
    }
  }, [formik.values.phone, setDiscountPhone]);

  const [hasInput, setHasInput] = useState(false);
  useEffect(() => {
    if (inputPhone.length > 0) {
      setHasInput(false);
    } else {
      setHasInput(true);
    }
  }, [inputPhone])

  return (
    <div className="block-form__form__left__client">
      <div className="block-form__form__left__osobiste">
        <h5>Личные данные</h5>
        <div className="client-data-wrapp">
          <label className="client-data-label">
            <div>Имя <span>(обязательно)</span></div>
            <Input
              name="firstname"
              id="firstname_form"
              type='text'
              className={formik.touched.firstname && formik.errors.firstname ? 'error-input' : ''}
              placeHolder='Имя'
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.firstname}
            />
            {formik.touched.firstname && formik.errors.firstname ? (
              <span className="error-message">{formik.errors.firstname}</span>
            ) : null}
          </label>
          <label className="client-data-label">
            <div>Фамилия <span>(необязательно)</span></div>
            <Input
              name="lastname"
              type='text'
              className={formik.touched.lastname && formik.errors.lastname ? 'error-input' : ''}
              placeHolder='Фамилия'
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.lastname}
            />
          </label>
        </div>
        <div className="client-data-wrapp">
          <label className="client-data-label">
            <div>Email <span>(обязательно)</span></div>
            <Input
              name="email"
              type='email'
              placeHolder='me@contakt.ru'
              className={formik.touched.email && formik.errors.email ? 'error-input' : ''}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            {formik.touched.email && formik.errors.email ? (
              <span className="error-message">{formik.errors.email}</span>
            ) : null}
          </label>
          <label className="client-data-label">
            <div>Телефон <span>(обязательно)</span></div>

            <div className='phone-wrapp'>
              <Input
                name="phone"
                type='tel'
                className={formik.touched.phone && formik.errors.phone ? 'error-input' : ''}
                placeHolder='+7 (***) ***-**-**'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={isFocused ? inputCode + inputPhone : ''}
                maxLength={18}
                onInput={onPhoneInput}
                onKeyDown={onPhoneKeyDown}
                onPaste={onPhonePaste}
                onClick={onPhoneClick}
                onFocus={(e) => { setIsFocused(true); onPhoneFocus(e) }}
                autoComplete="off-phone"
              />
              {isFocused && hasInput &&
                <span className='other-placeholder'>
                  ***) ***-**-**
                </span>
              }
            </div>
            {formik.touched.phone && formik.errors.phone ? (
              <span className="error-message">{formik.errors.phone}</span>
            ) : null}
            
          </label>
        </div>
        <div className="client-data-wrapp-address">
          <label className="client-data-label address">
            <div>Адрес <span>(обязательно)</span></div>
            <Input
              name="adress"
              type='text'
              placeHolder='Улица, № дома и квартиры'
              className={formik.touched.adress && formik.errors.adress ? 'error-input' : ''}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.adress}
            />
            {formik.touched.adress && formik.errors.adress ? (
              <span className="error-message">{formik.errors.adress}</span>
            ) : null}
          </label>
          <label className="client-data-label code">
            <div>Индекс <span>(необязательно)</span></div>

            <Input
              name="kod_index"
              type='text'
              placeHolder='______'
              className={formik.touched.kod_index && formik.errors.kod_index ? 'error-input' : ''}
              onChange={(e) => {
                const filteredValue = e.target.value.replace(/[^0-9-]/g, ''); // Фильтрация: оставляем только цифры и "-"
                formik.setFieldValue('kod_index', filteredValue);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.kod_index}
            />
          </label>
        </div>
        <label className="client-data-label">
          <div>Дополнительное поле информации <span>(необязательно)</span></div>
          {/* <textarea name="notes"
            value={informacja}
            onChange={event => props.setField('informacja', event.target.value)}
            placeholder="Text" /> */}
          <textarea
            name="notes"
            id="form-notes"
            placeholder='Текст'
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.notes}
          />
        </label>
      </div>
    </div>
  )
}